/**
 * Feb 2026 — Cluster cover image manifest.
 *
 * One 16:9 editorial photo per cluster. Generated once via
 * /app/backend/scripts/generate_cluster_covers.py and served from
 * /api/uploads/cluster-covers/<cluster-key>.png.
 *
 * Keys match `cluster.key` values in `locationTree.js` REGIONS.
 */

const CLUSTER_KEYS = [
  // Sunshine Coast
  "noosa-hinterland",
  "coolum-peregian",
  "maroochy-mooloolah",
  "hinterland-glasshouse",
  // Northern Rivers
  "byron-shire",
  "ballina-shire",
  "lismore-region",
  "tweed-shire",
  // Toowoomba
  "toowoomba-city",
  "darling-downs-east",
  "southern-downs",
  // Dayboro
  "dayboro-village",
  "samford-valley",
  "kilcoy-hinterland",
  // Redlands
  "redlands",
  "moreton-bay-islands",
  "logan-north",
  // Tweed / Byron
  "border-coastal",
  "tweed-valley-hinterland",
  "byron-hinterland",
  // Central Coast NSW
  "gosford-region",
  "wyong-lakes",
  "central-coast-plateau",
  // Riverina & Southern Tablelands
  "riverina-central",
  "riverina-mia",
  "southern-tablelands",
  // TNQ
  "cairns-region",
  "port-douglas-daintree",
  "atherton-tablelands",
  // Gold Coast
  "gold-coast-north",
  "gold-coast-south",
  "gold-coast-hinterland",
  // Cooloola & Fraser Coast
  "cooloola-coast",
  "hervey-bay-region",
  "kgari-fraser-island",
  // South Gippsland
  "bass-coast",
  "south-gippsland-inland",
  "corner-inlet",
  // Top End
  "darwin-region",
  "katherine-region",
  "tiwi-arnhem",
  // Bathurst & Central Tablelands (NSW) — Jun 2026
  "bathurst-region",
  "orange-cabonne",
  "lithgow-oberon",
];

export const CLUSTER_COVERS = Object.fromEntries(
  CLUSTER_KEYS.map((key) => [
    key,
    {
      src: `/api/uploads/cluster-covers/${key}.png`,
      alt: `Editorial photograph representative of the ${key.replace(/-/g, " ")} cluster.`,
    },
  ]),
);

export function cover_for_cluster(clusterKey) {
  return CLUSTER_COVERS[clusterKey] || null;
}
